export const FETCH_NEW_TICKETS = 'FETCH_NEW_TICKETS';
export const LIST_NEW_TICKETS = 'LIST_NEW_TICKETS';
export const ADD_NEW_TICKET = 'ADD_NEW_TICKET';

export const UPDATE_TICKET = 'UPDATE_TICKET';
export const SET_MARK = 'SET_MARK';


